// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3RQHg","label":"LabeledBox_label__2QXfo"};